import type React from 'react';
import { useMemo } from 'react';
import AkomiDialog from './AkomiDialog';
import AkomiDialogActions from './AkomiDialogActions';

interface RemoveDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (assetIds: string[]) => void;
  header?: string | null;
  assetIds?: string[];
}

const RemoveItemDialog: React.FC<RemoveDialogProps> = ({ isOpen, onClose, onDelete, header = null, assetIds = [] }) => {
  const headerText = useMemo(() => {
    return header
      ? header
      : `Remove ${assetIds.length > 1 ? 'these items' : 'this item'}? ${
          assetIds.length > 1 ? `(${assetIds.length})` : ''
        } `;
  }, [header, assetIds]);

  const onClickDelete = (): void => {
    onDelete(assetIds);
  };

  const onClickCancel = (): void => {
    onClose();
  };

  return (
    <AkomiDialog
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      title={headerText}
      actions={
        <AkomiDialogActions
          variant="delete-cancel"
          primaryLabel="Remove"
          onPrimary={onClickDelete}
          onSecondary={onClickCancel}
        />
      }
    >
      {/* Content area intentionally empty — the title conveys the message */}
      <span />
    </AkomiDialog>
  );
};

export default RemoveItemDialog;
